import type { PromptTemplate } from '@/components/chat/prompt-template.interface'

export const getPromptTemplateRowId = (row: PromptTemplate): string => row.id

export const promptTemplateSearchKeyList: (keyof PromptTemplate)[] = ['name', 'description']
